
import style from './style.scss';

import { h, Component } from 'preact';
import { route } from 'preact-router';

import Form from '../../../components/form';
import TopBar from '../../../components/topbar';

export default class NewPayment extends Component {
	onFinish = () => route('/')

	render(props, { payments }) {
		return (
			<section>
				<TopBar {...props} />

				<div class={`${style.payment_new} page`}>
					<Form onFinish={this.onFinish} {...props} />
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./routes/payments/new/index.js